import type { CSSObject } from "type/tss";

export const styles = () => {
	return ({
		// Flush against the field's left edge, filling its height, per the Display frames
		// (VPLAT 10 `2551:14077`, VPLAT 32 `2985:23184`).
		swatch: {
			alignSelf: "stretch",
			width: 48,
			flexShrink: 0,
			borderTopLeftRadius: 4,
			borderBottomLeftRadius: 4,
			padding: 0,
			border: "none",
			margin: 0,
		},
		button: {
			cursor: "pointer",
		},
	} satisfies Record<string, CSSObject>);
};
